import { api } from '../../shared/api/client';
import type { Role } from '../auth/api';

export interface AdminUser {
  id: string;
  email: string;
  role: Role;
  fullName: string;
  phone: string;
  clinics: string[];
  createdAt: string;
  updatedAt: string;
}

/** Статус письма с логином и паролем новому пользователю. */
export type CredentialsEmailStatus = 'sent' | 'failed' | 'disabled' | 'skipped';

export interface CreatedUser extends AdminUser {
  credentialsEmail: CredentialsEmailStatus;
}

export interface AdminUserInput {
  fullName: string;
  phone: string;
  email: string;
  role: Role;
}

export interface CreateUserInput {
  partnershipRequestId?: string;
  email: string;
  password: string;
  fullName?: string;
  phone?: string;
  role: Role;
  /** Отправить пользователю письмо с логином и паролем. */
  sendCredentials?: boolean;
}

export interface AdminStats {
  users: number;
  doctors: number;
  admins: number;
  patients: number;
  clinics: number;
  examinations: number;
}

export interface AdminDoctor {
  id: string;
  email: string;
  role: Role;
  fullName: string;
  phone: string;
  clinics: string[];
  patientCount: number;
  createdAt: string;
}

/** Врачи с клиниками и числом закреплённых пациентов (кабинет администратора). */
export async function listDoctorsDetailed(): Promise<AdminDoctor[]> {
  const { data } = await api.get<{ items: AdminDoctor[] }>('/v1/admin/doctors');
  return data.items;
}

export async function updateUser(id: string, body: AdminUserInput): Promise<AdminUser> {
  const { data } = await api.patch<AdminUser>(`/v1/admin/users/${id}`, body);
  return data;
}

/** Создание учётной записи администратором — единственный способ завести аккаунт. */
export async function createUser(body: CreateUserInput): Promise<CreatedUser> {
  const { data } = await api.post<CreatedUser>('/v1/admin/users', body);
  return data;
}

/** Сброс пароля администратором — все текущие сессии пользователя отзываются. */
export async function resetPassword(id: string, password: string): Promise<AdminUser> {
  const { data } = await api.patch<AdminUser>(`/v1/admin/users/${id}/password`, { password });
  return data;
}

export async function setUserClinics(id: string, clinicIds: string[]): Promise<AdminUser> {
  const { data } = await api.put<AdminUser>(`/v1/admin/users/${id}/clinics`, { clinicIds });
  return data;
}

export async function getStats(): Promise<AdminStats> {
  const { data } = await api.get<AdminStats>('/v1/admin/stats');
  return data;
}
